import React from 'react'
import NavBar from './NavBar'
import TabBar from './TabBar'
import Notification from '../General/Notification'
import TransactionCard from './TransactionCardJ1'
import FloatingIcon from '../General/FloatingIcon'
import Navbar from '../General/Navbar'

function Sommet() {
  return (
    <div>
      <NavBar/>  
      <TabBar/>
      <Notification/>
      <TransactionCard/>
      <FloatingIcon/>
      <Navbar/>
    </div>
  )
}

export default Sommet